import type { EditionAwarenessContextType } from './edition-awareness-context';

export function isPaidStandard({
	edition,
	isInTrial,
	isInPredunning,
}: EditionAwarenessContextType): boolean {
	return edition === 'standard' && !isInTrial && !isInPredunning;
}
